import React from 'react'
import { useTheme } from '@mui/material'

import CardColumn from '@SonarCX/components/atoms/CardColumn'
import Card from '@SonarCX/components/atoms/Card'

import { toTitleCase } from '@SonarCX/utilities'
import { getDate, getFrequency } from '../SubscriptionSettings/helpers'
import { useSubscription } from '@SonarCX/providers/SubscriptionProvider'
import useStyles, { getStatusColor } from './styles'

const SubscriptionCards: React.FC = () => {
  const theme = useTheme()

  const { subscriptions } = useSubscription()

  const classes = useStyles()

  return (
    <CardColumn className={classes.root}>
      {subscriptions.length === 0 && (
        <Card>
          <div className={classes.noData}>No subscriptions</div>
        </Card>
      )}

      {subscriptions.map((subscription, i) => (
        <Card key={`${subscription.name}-${i}`}>
          <div className={classes.dataRow}>
            <div>{subscription.name}</div>
          </div>

          <div className={classes.dataRow}>
            <div style={{ color: getStatusColor(subscription.status, theme) }}>
              {toTitleCase(subscription.status)}
            </div>
          </div>

          <div className={classes.dataRow}>
            <div>{getFrequency(subscription)}</div>
          </div>

          <div className={classes.dataRow}>
            <div className={classes.date}>{getDate(subscription)}</div>
          </div>
        </Card>
      ))}
    </CardColumn>
  )
}

export default SubscriptionCards
